// GENERATED by scripts/build-icons.mjs from icons/code.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Code = createIcon('code', [
  ['path', { d: "m16 18 6-6-6-6" }],
  ['path', { d: "m8 6-6 6 6 6" }],
])
